import { useState } from 'react'
import { mutate } from 'swr'
import { Update_Section } from '@graphql/mutations'
import { Library_Sections, Sections_Listing, Single_Section } from '@graphql/queries'
import { useApi } from '@hooks/useApi'

const useUpdateSection = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      data,
      Update_Section,
      successMessage ? successMessage : 'Avsnitt uppdaterat.',
      errorMessage
        ? errorMessage
        : 'Nåt gick fel när avsnittet skulle uppdateras.',
      async () => {
        await mutate(Sections_Listing) // refetch sections listing
        await mutate(Library_Sections)
        await mutate([Single_Section, data.id]) // refetch single section
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useUpdateSection }
